module.exports = __webpack_public_path__ + "static/media/751MeldrumStNW_2018-06-18_118.b3ae08c3.jpg";